import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { PageHeader } from '../components/UI';
import AiPrivacyCard from '../components/AiPrivacyCard';

export default function SettingsPage() {
  const { theme, toggle } = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      <PageHeader title="Settings" subtitle="Manage your account and preferences" />

      <div className="row g-4">
        {/* Profile info */}
        <div className="col-12 col-lg-6">
          <div className="sms-card h-100">
            <h6 style={{ fontSize: 13, fontWeight: 600, color: 'var(--sms-txt)', marginBottom: 16 }}>
              <i className="bi bi-person-circle me-2" />Account Info
            </h6>
            <div className="d-flex flex-column gap-3">
              {[
                { label: 'Full name',  value: user?.full_name },
                { label: 'Username',   value: user?.username },
                { label: 'Email',      value: user?.email },
                { label: 'Role',       value: user?.role === 'super_admin' ? 'Super Admin' : 'Admin' },
              ].map(f => (
                <div key={f.label}>
                  <div style={{ fontSize: 12, color: 'var(--sms-txt3)', marginBottom: 3 }}>{f.label}</div>
                  <div style={{ fontSize: 13, color: 'var(--sms-txt)', fontWeight: 500 }}>{f.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Appearance */}
        <div className="col-12 col-lg-6">
          <div className="sms-card h-100">
            <h6 style={{ fontSize: 13, fontWeight: 600, color: 'var(--sms-txt)', marginBottom: 16 }}>
              <i className="bi bi-palette me-2" />Appearance
            </h6>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid var(--sms-bdr)' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--sms-txt)' }}>Theme</div>
                <div style={{ fontSize: 12, color: 'var(--sms-txt2)', marginTop: 2 }}>
                  Currently using {theme} mode
                </div>
              </div>
              <button className="sms-btn sms-btn-outline" onClick={toggle}>
                <i className={`bi ${theme === 'dark' ? 'bi-sun' : 'bi-moon'}`} />
                Switch to {theme === 'dark' ? 'light' : 'dark'}
              </button>
            </div>
          </div>
        </div>

        {/* Quick links for super_admin */}
        {user?.role === 'super_admin' && (
          <div className="col-12 col-lg-6">
            <div className="sms-card h-100">
              <h6 style={{ fontSize: 13, fontWeight: 600, color: 'var(--sms-txt)', marginBottom: 16 }}>
                <i className="bi bi-shield-lock me-2" />Admin Tools
              </h6>
              <div className="d-flex flex-column gap-2">
                <button className="sms-btn sms-btn-outline w-100 justify-content-start"
                  onClick={() => navigate('/system/users')}>
                  <i className="bi bi-person-gear" /> Manage Users
                </button>
                <button className="sms-btn sms-btn-outline w-100 justify-content-start"
                  onClick={() => navigate('/system/permissions')}>
                  <i className="bi bi-toggles" /> Configure Permissions
                </button>
                <button className="sms-btn sms-btn-outline w-100 justify-content-start"
                  onClick={() => navigate('/system/audit-logs')}>
                  <i className="bi bi-shield-check" /> View Audit Logs
                </button>
              </div>
            </div>
          </div>
        )}

        {/* AI data protection for admin and super_admin */}
        {(user?.role === 'super_admin' || user?.role === 'admin') && (
          <div className="col-12">
            <AiPrivacyCard />
          </div>
        )}
      </div>
    </>
  );
}